"use client";
import { Link, useNavigate } from "react-router-dom";
import { Users } from "lucide-react";
import { successToast } from "../../../utils/toasters";

function GroupCard({ group, onJoin, onLeave, isProcessing }) {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("access_token") !== null;

  const memberCount = parseInt(group.member_count || 0, 10);

  const handleToggleJoin = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isLoggedIn) {
      localStorage.setItem("pendingJoinGroupId", group.groupid);
      successToast("Please login to join groups");
      navigate("/signin", { state: { from: `/groups/${group.groupid}` } });
      return;
    }

    if (group.isJoined) {
      onLeave && onLeave(group.groupid);
    } else {
      onJoin && onJoin(group.groupid);
    }
  };

  return (
    <Link to={`/groups/${group.groupid}`} className="block">
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="w-full h-32 relative overflow-hidden">
          <img
            src={group.coverphoto || "/placeholder.svg"}
            alt={group.name}
            className="w-full h-full object-cover"
          />
        </div>
        <h3 className="font-semibold text-base text-white rounded-b-md p-4" style={{ backgroundColor: "#0A0A0A99" }}>
          {group.name}
        </h3>
        <div className="p-4">
          <p className="text-sm text-gray-600 mt-1 line-clamp-2">
            {group.description}
          </p>
          <div className="flex justify-between items-center mt-4">
            <div className="flex items-center text-sm text-gray-600">
              <Users className="h-5 w-5 mr-1 text-gray-500" />
              <span>+{memberCount}</span>
            </div>
            <button
              onClick={handleToggleJoin}
              disabled={isProcessing}
              className={`px-5 py-1.5 rounded-full font-medium text-sm transition-colors ${
                isProcessing ? "opacity-50 cursor-not-allowed" : ""
              } ${
                group.isJoined
                  ? "bg-gray-200 text-gray-700"
                  : "bg-[#7B189F] text-white hover:bg-[#6a1489]"
              }`}
            >
              {isProcessing ? (
                <svg
                  className="animate-spin h-4 w-4 text-white mx-auto"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              ) : group.isJoined ? (
                "Joined"
              ) : (
                "Join"
              )}
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default GroupCard;
